<interacta-dialog
    [contentOverflowAuto]="false"
    [customRegularHeight]="true"
    [isOpen]="isOpen()"
    [size]="'small'"
    (closing)="close()"
>
    <h2 class="typo-t6" title>
        {{ 'AI.SIDE_PANEL.HISTORY.RENAME_TITLE' | translate }}
    </h2>

    <form class="mt-24" content (submit)="saveTitle($event)">
        <interacta-required-legend class="mb-16" />
        <interacta-form-field
            [control]="titleControl"
            [isRequired]="true"
            [name]="'AI.SIDE_PANEL.HISTORY.TITLE_LABEL' | translate"
        >
            <interacta-input-text
                [control]="titleControl"
                [setFocus]="inputFocused()"
            />
        </interacta-form-field>
        <!--
            required to correctly submit the form without
            bringing the two buttons below into the <form>
            (which would change the layout of the dialog)
        -->
        <button aria-hidden="true" class="hidden" type="submit"></button>
    </form>

    <interacta-dialog-buttons>
        <button
            interacta-dialog-button
            type="button"
            [label]="'UI.BUTTON.CANCEL' | translate"
            [style]="'text'"
            (click)="closing.emit()"
        ></button>
        <button
            interacta-dialog-button
            type="button"
            [disabled]="titleControl.invalid"
            [label]="'UI.BUTTON.SAVE' | translate"
            [style]="'filled'"
            (click)="saveTitle()"
        ></button>
    </interacta-dialog-buttons>
</interacta-dialog>
